(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('quickSidebarTasks', ['QuickSidebarTasksService', QuickSidebarTasksFn]);

    /* main quick sidebar directive for daytask-area */
    function QuickSidebarTasksFn(QuickSidebarTasksService) {
        var directive = {
            restrict: 'A',
            templateUrl: '/app/ringfoon/templates/quick-sidebar-tasks.template.html',
            scope: true,
            link: link
        };
        return directive;

        function link(scope, element) {
            // task list
            QuickSidebarTasksService.setTasksDivHeightForScrollBar();
            
            window.addEventListener('resize', function(event) {
                QuickSidebarTasksService.setTasksDivHeightForScrollBar();
            }, true);

            // list of filtered daytasks
            scope.data = QuickSidebarTasksService.data;

            // export methods
            scope.filter = QuickSidebarTasksService.filter;
            scope.reset = QuickSidebarTasksService.reset;
            scope.toggleMyTasksText = QuickSidebarTasksService.toggleMyTasksText;
            scope.toggleFilterMoves = QuickSidebarTasksService.toggleFilterMoves;
            scope.toggleFilterAdmins = QuickSidebarTasksService.toggleFilterAdmins;
            scope.toggleFilterImportant = QuickSidebarTasksService.toggleFilterImportant;

            // if the autorefresh toggle has been changed
            let autoRefreshToggleListener = scope.$on(QuickSidebarTasksService.Broadcast.AutoRefreshToggleChanged, function (event, notificationList) {
                activate();
            });
            
            // activate
            activate();

            // activate
            function activate() {
                // register websocket for quick-sidebar tasks
                QuickSidebarTasksService.registerWebsocket();

                // load daytasks
                QuickSidebarTasksService.getAll().then(function (result) {
                    // slim scroll
                    //el.slimScroll({ height: '90vh' }); // 100 % viewport height    
                });

            } // activate           


            // destroy
            scope.$on("$destroy", function () {
                scope.filterValue = null;
                // clear
                QuickSidebarTasksService.data.filtered = [];

                autoRefreshToggleListener();
                autoRefreshToggleListener = null;
            });
        }
    }

})();